import React from 'react';
import { MobileMenuButton } from './MobileMenuButton';
import { MobileMenuContent } from './MobileMenuContent';
import { User as UserType } from '../../../features/auth/types/user';
import { NavItem } from './types';

interface MobileMenuProps {
  mobileMenuOpen: boolean;
  setMobileMenuOpen: (open: boolean) => void;
  isDashboardPage: boolean;
  isAuthenticated: boolean;
  user: UserType | null;
  mainNavItems: NavItem[];
  handleSignIn: () => void;
  logout: () => void;
}

export const MobileMenu: React.FC<MobileMenuProps> = ({
  mobileMenuOpen,
  setMobileMenuOpen,
  isDashboardPage,
  isAuthenticated,
  user,
  mainNavItems,
  handleSignIn,
  logout,
}) => {
  return (
    <div className="relative" data-mobile-menu>
      <MobileMenuButton
        mobileMenuOpen={mobileMenuOpen}
        setMobileMenuOpen={setMobileMenuOpen}
        isDashboardPage={isDashboardPage}
      />

      {mobileMenuOpen && (
        <div className="fixed left-1/2 transform -translate-x-1/2 top-20 mt-1 max-w-sm w-[95vw] bg-white/90 backdrop-blur-md text-gray-900 rounded-xl shadow-md py-3 px-3 z-[100] flex flex-col gap-2 border border-gray-200">
          <MobileMenuContent
            isAuthenticated={isAuthenticated}
            user={user}
            mainNavItems={mainNavItems}
            setMobileMenuOpen={setMobileMenuOpen}
            handleSignIn={handleSignIn}
            logout={logout}
          />
        </div>
      )}
    </div>
  );
}; 